module.exports = __webpack_public_path__ + "static/media/minus.455d4953.svg";